/* global $ */

import './helpers/requestIdleCallback';
import 'lazysizes';

__webpack_public_path__ = '/front_assets/'; // eslint-disable-line

Number.isNaN = Number.isNaN || function isNaNPolyfill(value) {
  return value !== value; // eslint-disable-line no-self-compare
};

const token = document.head.querySelector('meta[name="csrf-token"]').content;

$.ajaxSetup({
  beforeSend: (xhr) => {
    xhr.setRequestHeader('X-CSRF-TOKEN', token);
  },
});
